function sanitizePath(path: string) {
    if (path.startsWith('http')) {
        return path.replace(/\/$/, '');
    }
    const sanitized = path.replace(/^\/|\/$/g, '');
    return sanitized || 'home';
}

export function compareLink(pathname?: string | null, href?: string | null, partial = false) {
    if (pathname === null || pathname === undefined || href === null || href === undefined) {
        return false;
    }
    const pathnameClean = sanitizePath(pathname);
    const hrefClean = sanitizePath(href);

    return pathnameClean === hrefClean || (partial && hrefClean.startsWith(pathnameClean));
}
